export default "__VITE_ASSET__Ce9RDRF5__"